import { Alignment, Button, Classes, Navbar } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";
import styled from "styled-components";

import { ERoutes } from "../AppRouter";
import assets from "../assets";
import { CustomerColors } from "../theme";
import { AppBreadcrumb } from "./AppBreadcrumb";
import { UserMenu } from "./UserMenu";
import { LanguageSelector } from "./LanguageSelector";
import { useCommonHooks } from "../hooks";

interface IHeaderProps {
  showMenuIcon: boolean;
  toggleLeftMenu?: () => void;
  isDark?: boolean;
  onDarkSwitchChange?: (e: boolean) => void;
}

const NavBarStyled = styled(Navbar)`
  /* background-image: linear-gradient(to right,#0E5A8A,#0E5A8A 25%,rgba(255, 255, 255, 0.5),white 65%,#0E5A8A 80%), url(${assets
    .images.nsiLogo}) !important; */
  /* background-position: 0% 35%; */
  height: 50px !important;
  padding-left: 0 !important;

  & > .${Classes.NAVBAR_GROUP} {
    height: 50px;
  }

  /* Change colors for customer */
  /* background: ${CustomerColors.green} !important; */
`;
const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  min-width: 224px;
  text-align: center;
  height: 100%;

  &:hover {
    cursor: pointer;
  }
`;
const HeaderText = styled.div`
  font-size: 1.2rem;
  font-weight: bold;
`;

const LogoImage = styled.img`
  height: 40px;
  border-radius: 5px;
  margin-left: 5px;
  padding-left: 20px;
  padding-right: 20px;
`;

export const Header: React.FC<IHeaderProps> = (props) => {
  const { router, breadCrumbs } = useCommonHooks();
  return (
    <div className={Classes.DARK}>
      <NavBarStyled>
        <Navbar.Group align={Alignment.LEFT} style={{ width: 294 }}>
          {props.toggleLeftMenu && props.showMenuIcon && (
            <>
              <Button
                icon={IconNames.MENU}
                minimal={true}
                onClick={props.toggleLeftMenu}
              />
              <Navbar.Divider />
            </>
          )}
          <LogoContainer
            style={{}}
            onClick={() => router.push(`${ERoutes.home}`)}
          >
            <LogoImage src={assets.images.headerLogo} alt="logo" />
            <Navbar.Divider />
            <HeaderText>My VIA Pro</HeaderText>
          </LogoContainer>
        </Navbar.Group>
        <Navbar.Group align={Alignment.LEFT}>
          <Navbar.Heading>
            <AppBreadcrumb items={breadCrumbs} />
          </Navbar.Heading>
        </Navbar.Group>
        <Navbar.Group align={Alignment.RIGHT}>
          <LanguageSelector />
          <UserMenu />
        </Navbar.Group>
      </NavBarStyled>
    </div>
  );
};
